import request from '@/util/request'
export function apiGetHome (data) {
  // 设备库首页
  return request({
    url: `/device-s/device/device-lib-home`,
    method: 'post',
    data
  })
}
export function apiGetList (param, data) {
  // 设备列表
  return request({
    url: `/device-s/device/list`,
    method: 'post',
    params: param, // $.param(data)
    data
  })
}

export function getDeviceDetail (data) {
  // 设备列表
  return request({
    url: `/device-s/device/detail`,
    method: 'post',
    data
  })
}

export function getProductList (params) {
  // 设备列表
  return request({
    url: `/device-s/device/productList`,
    method: 'get',
    params
  })
}

// 日统计
export function deviceParams (parm) {
  return request({
    url: `/device-s/device/params`,
    method: 'get',
    params: parm
  })
}

// 日统计
export function deviceStatsDay (deviceId, parm) {
  let parms = parm
  parms.lan = stage.languageId
  return request({
    url: `/device-s/device/${deviceId}/stats/day`,
    method: 'get',
    params: parms
  })
}

// 日范围统计
export function deviceStatsDayRange (deviceId, parm) {
  return request({
    url: `/device-s/device/${deviceId}/stats/dayrange`,
    method: 'get',
    params: parm
  })
}

// 月统计
export function apiDeviceStatsMonth (deviceId, parm) {
  return request({
    url: `/report-s/device/${deviceId}/stats/month`,
    method: 'get',
    params: parm
  })
}
// 年统计
export function apiDeviceStatsYear (deviceId, parm) {
  return request({
    url: `/report-s/device/${deviceId}/stats/year`,
    method: 'get',
    params: parm
  })
}
// 总统计
export function apiDeviceStatsTotal (deviceId, parm) {
  return request({
    url: `/report-s/device/${deviceId}/stats/total`,
    method: 'get',
    params: parm
  })
}
// 月统计
export function deviceStatsMonth (siteId, deviceId, parm) {
  return request({
    url: `/device-s/device/${siteId}/${deviceId}/stats/month`,
    method: 'get',
    params: parm
  })
}

// 年统计
export function deviceStatsYear (siteId, deviceId, parm) {
  return request({
    url: `/device-s/device/${siteId}/${deviceId}/stats/year`,
    method: 'get',
    params: parm
  })
}

// 年统计
export function deviceStatsTotal (siteId, deviceId, parm) {
  return request({
    url: `/device-s/device/${siteId}/${deviceId}/stats/total`,
    method: 'get',
    params: parm
  })
}
// 删除设备列表

export function DelDevice (data) {
  return request({
    url: `/device-s/device/delete-device`,
    method: 'post',
    data
  })
}

// 检验sn
export function checkSN (deviceSn) {
  return request({
    url: `/device-s/device/network-check-sn/${deviceSn}`,
    method: 'get'
  })
}

// 获取通讯关系
export function getCommunication (deviceId) {
  return request({
    url: `/device-s/device/get-communication/${deviceId}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/device/list.js